import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import * as React from 'react';

const ModalNoResults = ({
  message = 'To see more results, try adjusting some of your filters or clear all filters',
}) => {
  return (
    <Box
      color="gray.800"
      fontSize="sm"
      letterSpacing={0}
      backgroundColor="gray.50"
      borderRadius="10px"
      paddingX={4}
      paddingY={5}
    >
      <Text>No results found. </Text>
      {!!message && <Text>{message}</Text>}
    </Box>
  );
};

ModalNoResults.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
ModalNoResults.defaultProps = {
  message:
    'To see more results, try adjusting some of your filters or clear all filters',
};

export default ModalNoResults;
